import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=0a372f6d&scoped=true"
import script from "./personal-center.vue?vue&type=script&lang=js"
export * from "./personal-center.vue?vue&type=script&lang=js"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=0a372f6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a372f6d",
  null
  
)

export default component.exports